import { render, staticRenderFns } from "./NetworkNotification.vue?vue&type=template&id=f36d9a7c&scoped=true&"
import script from "./NetworkNotification.vue?vue&type=script&lang=js&"
export * from "./NetworkNotification.vue?vue&type=script&lang=js&"
import style0 from "./NetworkNotification.vue?vue&type=style&index=0&id=f36d9a7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36d9a7c",
  null
  
)

export default component.exports